var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"steps"},[_vm._m(0),_c('div',{staticClass:"steps_content"},[_vm._t("default")],2)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"steps_header"},[_c('img',{staticClass:"steps_header_logo",attrs:{"src":require("@/assets/builderall-logo-name.svg"),"alt":"Builderall","title":"Builderall"}})])
}]

export { render, staticRenderFns }